import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { useT } from '../i18n.tsx';

/**
 * Beitritts-Block: QR-Code plus Raumcode zum Abtippen.
 *
 * Der QR-Code wird lokal als Data-URL gerendert -- kein externer
 * Dienst, damit das Spiel auch in einem abgeschotteten Netz laeuft.
 */
export function QrJoin({ joinUrl, code }: { joinUrl: string; code: string }) {
  const t = useT();
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;

    void QRCode.toDataURL(joinUrl, {
      width: 360,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#0b0b14', light: '#ffffff' },
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch((error: unknown) => {
        console.error('[qr] Erzeugung fehlgeschlagen:', error);
      });

    return () => {
      cancelled = true;
    };
  }, [joinUrl]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(joinUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard-API braucht HTTPS bzw. localhost. Kein Drama.
    }
  };

  return (
    <div className="stack" style={{ alignItems: 'center', textAlign: 'center' }}>
      <div className="panel__title">{t('lobby.scanQr')}</div>

      {dataUrl ? (
        <img className="qr" src={dataUrl} alt={`QR-Code: ${joinUrl}`} />
      ) : (
        <div className="qr" aria-hidden="true" />
      )}

      <div>
        <div className="text-xs text-dim">{t('lobby.code')}</div>
        <div className="room-code">{code}</div>
      </div>

      <button type="button" className="btn btn--ghost" onClick={() => void copy()}>
        {copied ? t('common.copied') : `${t('common.copy')}: ${joinUrl.replace(/^https?:\/\//, '')}`}
      </button>
    </div>
  );
}
